export enum SearchEventType {
  PREFIX = 'prefix',
  PLAN = 'plan'
}
